<app-vehicles *ngIf="fleetId.length > 0" [fleetId]="fleetId" [fleetName]="fleetName"></app-vehicles>